import { Visit } from '../components/visit/Visit';

export const VisitContainer = Visit;
